import { Injectable } from '@angular/core';
import { Statistics } from 'app/trello/models/board-summary';
import { ListChartData } from 'app/trello/models/charts';
import { StatisticsAggregator } from 'app/trello/utility/statistics-aggregator';
import { StructureTransformer } from 'app/trello/utility/structure-transformer';

@Injectable({
  providedIn: 'root'
})
export class ListChartDataAggregator {

  constructor(
    private readonly statisticsAggregator: StatisticsAggregator,
    private readonly statisticsTransformer: StructureTransformer,
  ) {
  }

  public aggregate(
    stats: Statistics,
    aggregationLevel: 'day' | 'week' | 'month' = 'day'
  ): ListChartData {

    const totalListCardsData =
      this.statisticsAggregator.aggregateCountDistinct(
        stats.list.total.day || {},
        aggregationLevel,
      );

    const movedIntoListData =
      this.statisticsAggregator.aggregateCountDistinct(
        this.statisticsTransformer.mergeInnerArrays2D(stats.list.movedIn) || {},
        aggregationLevel,
      );

    const movedOutOfListData =
      this.statisticsAggregator.aggregateCountDistinct(
        this.statisticsTransformer.mergeInnerArrays2D(stats.list.movedOut) || {},
        aggregationLevel,
      );

    const listDurationData =
      this.statisticsAggregator.aggregateDuration(
        this.statisticsTransformer.collectInnerValues2D(stats.list.duration) || {},
        aggregationLevel,
      );

    return {
      totalCards: totalListCardsData,
      movedIn: movedIntoListData,
      movedOut: movedOutOfListData,
      duration: listDurationData,
    };
  }

}
